export default __webpack_public_path__ + "static/media/PMR-Sunset-Round-100px.dc067d3d.jpg";